import { useCallback } from 'react';
import { SectionRow } from '~/components/dialogs/settings/SectionContainer';
import { StepSlider } from '~/components/ui/StepSlider';
import type { OrganizationSettings } from '~/types/organization';

const VISIBILITY_ITEMS = [
  { id: 'private', label: 'Private', description: 'Only owner can access', icon: 'i-heroicons:lock-closed', value: 0 },
  { id: 'secret', label: 'Secret', description: 'Accessible via shared URL', icon: 'i-heroicons:eye-slash', value: 1 },
  { id: 'public', label: 'Public', description: 'Everyone can view', icon: 'i-heroicons:globe-americas', value: 2 },
];

interface TeamProjectVisibilityProps {
  maxVisibility: OrganizationSettings['maxVisibility'];
  updateSetting: (settingName: keyof OrganizationSettings, value: string) => void;
}

export const TeamProjectVisibility = ({ maxVisibility, updateSetting }: TeamProjectVisibilityProps) => {
  const handleVisibilityChange = useCallback(
    (idx: number) => {
      const i = typeof idx === 'number' ? idx : 0;
      updateSetting('maxVisibility', VISIBILITY_ITEMS[i].id);
    },
    [updateSetting],
  );

  const valueIdx = VISIBILITY_ITEMS.findIndex((item) => item.id === maxVisibility);

  return (
    <SectionRow
      title="Project visibility level"
      description="Projects made inside this team workspace will only be allowed the visibility level granted below."
      layout="vertical"
      innerClassName="flex flex-col"
      titleClassName="font-semibold text-sm mb-1.5"
      descriptionClassName="text-sm max-w-[85%] mb-3.5"
      action={
        <StepSlider
          marks={VISIBILITY_ITEMS}
          value={valueIdx}
          onChange={handleVisibilityChange}
          minValue={0}
          maxValue={VISIBILITY_ITEMS.length - 1}
          className="w-full"
        />
      }
    />
  );
};
